export default __webpack_public_path__ + "static/media/Whats_New.946d517d.png";